import script from "./AnimationControlsV2.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimationControlsV2.vue?vue&type=script&setup=true&lang=js"

import "./AnimationControlsV2.vue?vue&type=style&index=0&id=d02a76e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d02a76e4"]])

export default __exports__